import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Dashboard_component_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="dashboard_component_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Dashboard Component Overview</h2>
              <p>
                Dashboards can be found in the Settings - Dashboard section of
                the Nexoid application. Dashboards are fundamentally a record
                page without a record.
              </p>
              <p>
                To create a dashboard start by copy and pasting the{" "}
                <PageLink
                  to="Interface/layout_structure"
                  text="layout structure"
                />{" "}
                object which can be found in this website.
              </p>
              <p>
                Once you have created a layout, you can add components like
                charts and search results by following the same interface
                patterns used by records and record search pages.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Dashboard_component_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Dashboard_component_overview.js